import HowItWorksSection from "@/components/landing-v2/HowItWorksSection";
import VideoSection from "@/components/landing-v2/VideoSection";
import CreativeBoardSection from "@/components/landing-v2/CreativeBoardSection";
import ClientPanelSection from "@/components/landing-v2/ClientPanelSection";
import FeaturesGridSection from "@/components/landing-v2/FeaturesGridSection";

const BelowFoldSections = () => {
  return (
    <>
      <HowItWorksSection />
      <FeaturesGridSection />
      <VideoSection />
      <CreativeBoardSection />
      <ClientPanelSection />
    </>
  );
};

export default BelowFoldSections;
